import { Component } from "react";
import Popup from "..";
import RectButton from "../../ui/button/RectButton";
import CheckBox from "../../ui/CheckBox";
import Select from "../../ui/Select";
import Option from "../../ui/Select/Option";

import "./style.scss";

class UseTemplatePopup extends Component {
    render() {
        return (
            <Popup className="use-templates">
                <div className="column">
                    <div className="row">
                        <h3>Your Templates</h3>
                        <Select>
                            <Option value="1">All</Option>
                        </Select>
                    </div>
                    <div className="templates">
                        <CheckBox label="Basic Gift Thank You" />
                        <CheckBox label="The Year Ahead" />
                    </div>
                    <RectButton text="USE TEMPLATE" />
                </div>
            </Popup>
        )
    }
}

export default UseTemplatePopup;